import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, IconButton, Typography, Paper,
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { MENU_PROCESSO } from '../../mocks/processos.mock';
import * as C from '../../theme/colors.constants';

/**
 * Menu lateral DIREITO da tela de Controle de Processos.
 *
 * Ordem fixada pelo pedido: Acompanhamento, Histórico, Recebimento, Financeira,
 * Documentos, E-mail, Devedor, Cliente, Recálculos do Processo, Dados Jurídicos,
 * Fases.
 *
 * Nos prints o item ativo é uma pílula navy preenchida e os demais são texto
 * navy sobre branco. As setas ▲/▼ no topo e na base movem a seleção — elas
 * existem no print, então mantive o comportamento em vez de deixá-las inertes.
 */
export default function MenuLateralProcesso({ ativo, onChange }) {
  const indice = MENU_PROCESSO.findIndex(m => m.id === ativo);

  const mover = (delta) => {
    const proximo = Math.min(MENU_PROCESSO.length - 1, Math.max(0, indice + delta));
    onChange(MENU_PROCESSO[proximo].id);
  };

  return (
    <Paper
      component="nav"
      aria-label="Seções do processo"
      sx={{
        flexShrink: 0,
        width: 'clamp(128px, 8.4vw, 190px)',
        py: 0.5,
        alignSelf: 'flex-start',
        position: 'sticky',
        top: 12,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <IconButton size="small" aria-label="Seção anterior" onClick={() => mover(-1)} disabled={indice <= 0} sx={{ color: C.navy, py: 0 }}>
          <KeyboardArrowUpIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{
        display: 'flex', flexDirection: 'column', px: 0.75, py: 0.25,
      }}
      >
        {MENU_PROCESSO.map((m) => {
          const selecionado = m.id === ativo;
          return (
            <Box
              key={m.id}
              role="button"
              tabIndex={0}
              aria-current={selecionado ? 'true' : undefined}
              onClick={() => onChange(m.id)}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onChange(m.id)}
              sx={{
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: 999,
                px: 1,
                py: 0.6,
                my: 0.15,
                backgroundColor: selecionado ? C.navy : 'transparent',
                '&:hover': { backgroundColor: selecionado ? C.navyDark : C.paleGrey },
                '&:focus-visible': { outline: `2px solid ${C.navy}`, outlineOffset: -2 },
              }}
            >
              <Typography
                sx={{
                  fontSize: 'clamp(11px, 0.66vw, 15px)',
                  fontWeight: selecionado ? 700 : 500,
                  color: selecionado ? C.white : C.navy,
                  lineHeight: 1.25,
                }}
              >
                {m.label}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <IconButton
          size="small"
          aria-label="Próxima seção"
          onClick={() => mover(1)}
          disabled={indice >= MENU_PROCESSO.length - 1}
          sx={{ color: C.navy, py: 0 }}
        >
          <KeyboardArrowDownIcon fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );
}
MenuLateralProcesso.propTypes = {
  ativo: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
